import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import TopAppBar from './TopAppBar';
import WarnningBox from './WarnningBox';
import PanelButtons from './PanelButtons';
import postOrder from '../hooks/postOrder';


const useStyles = makeStyles((theme) => ({

  containerPage:{
    //display: 'flex', 
    //justifyContent: 'center', 
    //alignItems: 'center', 
    width: "100vw", 
    height: "100vh",
  },


  containerFlex:{
    width: "100%",
    marginTop: theme.spacing(2),
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
   //backgroundColor: "red",
  },

  containerInfo:{
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center',
    //backgroundColor: 'blue',
    width: "100%",
    padding: theme.spacing(2), 
    marginTop: "5vh",
    fontSize: "1.3rem",
    textAlign: "center", 
    [theme.breakpoints.up('md')]: {
      width: "40%",
      padding:  theme.spacing(2),
    },
  },

  image:{
    width:"150px",
  }

}));

const urlImage = "https://res.cloudinary.com/wikimenu/image/upload/v1620754385/store-app/chekout_zyd1l3.png"; 

export default function SendPage(props) {
  const classes = useStyles();
  const {view, store, order,strings, onBack, onSend, debug} = props; 
  
  const [error, setError] =  useState(false);


  const handlerBack = ()=>{
      onBack(); 
  }

  const handlerSend = ()=>{
   
      postOrder(order,store,debug,(response)=>{
            if(response){     
              onSend(response); 
            }else{
              setError(true); 
            }
      })
  }

  const isWhatsApp = ()=>{
    return order.type !="AUTO"
  }

  const messageConfirmation = ()=>{
    const info = isWhatsApp()?strings.message_checkout_ok:strings.message_checkout_local
    return !error ? info :  strings.message_checkout_error 
  }

  const actionSend = () =>{
    return isWhatsApp()?strings.action_send_to_whatsapp: strings.action_order;
  }

  return (
    <div className = {classes.containerPage}>  
       <TopAppBar title = {strings.title_send} />

        <div className = {classes.containerFlex}>      
          <div className = {classes.containerInfo}>
              <img className ={classes.image} src={urlImage} alt={strings.title_send}  />
            
              <WarnningBox
                  message={messageConfirmation()}    
                  icon={error}
              />
          </div>             
          <PanelButtons                    
                          labelCancel={strings.action_back}
                          labelNext={actionSend()}
                          onClickCancel={handlerBack}
                          onClickNext={handlerSend}
                          />   
          </div>
    </div>
  );
}
